import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {AcCounters, AcCountersSearchParams, AcCounterType, TotalConsumed} from '@accounting/_common/models/counter-indications.models';
import {ResourceType} from '@accounting/_common/models/_accounting.models';

export const LoadList = createAction(
    '[CounterIndications] Load List',
    props<{ payload: { loading: DahLoadingType, resourceType: ResourceType, clearState: boolean }, countersType: AcCounterType }>()
);

export const LoadListSuccess = createAction(
    '[CounterIndications] Load List Success',
    props<{ payload: { items: AcCounters[], pagination: DahPaginationModel, resourceType: ResourceType, clearState: boolean }, countersType: AcCounterType }>()
);

export const LoadTotalConsumed = createAction(
    '[CounterIndications] Load Total Consumed',
    props<{ payload: { resourceType: ResourceType }, countersType: AcCounterType }>()
);

export const LoadTotalConsumedSuccess = createAction(
    '[CounterIndications] Load Total Consumed Success',
    props<{ payload: { totalConsumed: TotalConsumed, resourceType: ResourceType }, countersType: AcCounterType }>()
);

export const LoadListFailure = createAction(
    '[CounterIndications] Load List Failure',
    props<{ payload: { error: HttpErrorResponse, resourceType: ResourceType }, countersType: AcCounterType }>()
);

export const SetPagination = createAction(
    '[CounterIndications] Set Pagination',
    props<{ payload: { next: boolean, resourceType: ResourceType }, countersType: AcCounterType }>()
);

export const SetPeriod = createAction(
    '[CounterIndications] Set Period',
    props<{ payload: { period: string }, countersType: AcCounterType }>()
);

export const SetFilter = createAction(
    '[CounterIndications] Set Filter',
    props<{ payload: { filter: AcCountersSearchParams }, countersType: AcCounterType }>()
);

export const SetLoading = createAction(
    '[CounterIndications] Set Loading',
    props<{ payload: { loading: DahLoadingType, resourceType: ResourceType }, countersType: AcCounterType }>()
);

export const SetItemsLoading = createAction(
    '[CounterIndications] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean, resourceType: ResourceType }, countersType: AcCounterType }>()
);

export const UpdateListItem = createAction(
    '[CounterIndications] Update List Item',
    props<{ payload: { item: AcCounters, resourceType: ResourceType }, countersType: AcCounterType }>()
);

export const SaveFirstPage = createAction(
    '[CounterIndications] Save First Page',
    props<{ payload: { items: AcCounters[], resourceType: ResourceType }, countersType: AcCounterType }>()
);

export const SetInitialState = createAction(
    '[CounterIndications] Set Initial State'
);
